import { getCdnUrl } from "@/config/cdn"

// Shared image configuration for landing page components
export const LANDING_IMAGES = [
  {
    filename: getCdnUrl('images/foveate_1920s_vintage_poster_of_the_chrysler_building_in_manh_b6b8edaf-f240-4208-b156-23030c5c85c4_2.png'),
    caption: 'Chrysler Building',
    title: 'Chrysler Building',
  },
  {
    filename: getCdnUrl('images/foveate_1920s_vintage_poster_of_the_empire_state_building_in__3c14a294-a440-412e-a176-32bd493ea736_2.png'),
    caption: 'Empire State Building',
    title: 'Empire State Building',
  },
  {
    filename: getCdnUrl('images/foveate_1920s_vintage_poster_of_the_golden_temple_in_kyoto_co_eb0df6fb-4c9f-4060-8ea8-42baf900f421_0.png'),
    caption: 'Golden Temple',
    title: 'Golden Temple',
  },
  {
    filename: getCdnUrl('images/foveate_bowl_of_ramen_in_kyoto_colorful_and_lively_film_grain_2f03682d-dae0-439d-b2dc-151f5c2b0602_2.png'),
    caption: 'Kyoto Ramen',
    title: 'Kyoto Ramen',
  },
  {
    filename: getCdnUrl('images/foveate_buddhist_zen_garden_in_kyoto_colorful_and_lively_film_dd02e6a7-ef25-4fb3-8c06-1d2f1f4d12d2_1.png'),
    caption: 'Zen Garden',
    title: 'Zen Garden',
  },
  {
    filename: getCdnUrl('images/foveate_buddhist_zen_garden_in_kyoto_colorful_and_lively_film_dd02e6a7-ef25-4fb3-8c06-1d2f1f4d12d2_3.png'),
    caption: 'Japanese Garden',
    title: 'Japanese Garden',
  },
  {
    filename: getCdnUrl('images/foveate_poster_of_the_subway_J_train_in_brooklyn_colorful_and_1222a9fd-aaa2-4565-9063-cfe0d7a8758a_2.png'),
    caption: 'Brooklyn Subway',
    title: 'Brooklyn Subway',
  },
  {
    filename: getCdnUrl('images/foveate_russ_and_daughters_cafe_full_of_people_in_the_lower_e_beb3bad6-fa18-4de2-a590-2ffd72aab0a6_2.png'),
    caption: 'Russ & Daughters',
    title: 'Russ & Daughters',
  },
  {
    filename: getCdnUrl('images/foveate_vintage_poster_of_the_oculus_in_manhattan_colorful_an_727f92de-8ab0-44b0-ad9d-b35cd4fb7376_0.png'),
    caption: 'Manhattan Oculus',
    title: 'Manhattan Oculus',
  },
] as const

// First 4 images for hero section cycling with depth maps for parallax effect
export const HERO_IMAGES = [
  {
    original: getCdnUrl('images/foveate_1920s_vintage_poster_of_the_chrysler_building_in_manh_b6b8edaf-f240-4208-b156-23030c5c85c4_2.png'),
    depth: getCdnUrl('images/depth/chrysler_building_depth.png'),
  },
  {
    original: getCdnUrl('images/foveate_1920s_vintage_poster_of_the_empire_state_building_in__3c14a294-a440-412e-a176-32bd493ea736_2.png'),
    depth: getCdnUrl('images/depth/empire_state_building_depth.png'),
  },
  {
    original: getCdnUrl('images/foveate_1920s_vintage_poster_of_the_golden_temple_in_kyoto_co_eb0df6fb-4c9f-4060-8ea8-42baf900f421_0.png'),
    depth: getCdnUrl('images/depth/golden_temple_depth.png'),
  },
  {
    original: getCdnUrl('images/foveate_bowl_of_ramen_in_kyoto_colorful_and_lively_film_grain_2f03682d-dae0-439d-b2dc-151f5c2b0602_2.png'),
    depth: getCdnUrl('images/depth/ramen_depth.png'),
  },
]

// All images for grid section
export const GRID_IMAGES = LANDING_IMAGES.map((img) => ({
  src: img.filename,
  caption: img.caption,
}))

// All images for suggestions grid
export const SUGGESTION_IMAGES = LANDING_IMAGES.map((img) => ({
  src: img.filename,
  title: img.title,
}))
